import { render, staticRenderFns } from "./PopupBase.vue?vue&type=template&id=00880c36&"
import script from "./PopupBase.vue?vue&type=script&lang=js&"
export * from "./PopupBase.vue?vue&type=script&lang=js&"
import style0 from "./PopupBase.vue?vue&type=style&index=0&id=00880c36&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports